export const getDefaultColor = () => '#327DFF';

export const getColors = () => [
  '#DB3E00',
  '#FCB900',
  '#008B02',
  '#006B76',
  getDefaultColor(),
  '#5300EB',
];
